const jsPopOver = () => {

    let popover = $('.js-popover');

    // Reinit popovers after change list view
    $(document).on('click', '.js-enable-list, .js-disable-list', function () {
        popover.popover('destroy');

        setTimeout(function () {
            initPopovers();
        }, 200);
    });


    function initPopovers() {
        popover.on('click', function(e) {
            e.preventDefault();
        });

        popover.each(function (index, element) {
            var $this = $(this);

            $this.popover({
                html: true,
                container: $this.parents('.js-list-grid-viewer-viewport'),
                viewport: $this.parents('.js-list-grid-viewer-viewport'),
                placement: 'top',
                title: '<span class="btn-popover-close"></span>',
                content: function () {
                    return $($this.attr('href')).html();
                }
            });
        });

        popover.on('show.bs.popover', function (e) {
            popover.not($(this)).each(function(index, el) {
                var $this = $(this);

                $this.data("bs.popover").inState.click = false;
            });

            popover.not($(this)).popover('hide');
        });
    }

    initPopovers(); // First init call

    // Hide all popover on close btn
    $(document).on('click', '.btn-popover-close', function () {
        popover.each(function(index, el) {
            var $this = $(this);

            $this.data("bs.popover").inState.click = false;
        });

        popover.popover('hide');
    });

    // Close popover when clicking anywhere on the screen
    $(document).on('click', function (e) {
        $('.js-popover').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            var target = $(e.target);
            if (
                   !target.is('.popover')
                && !target.is('.popover *') 
                && !target.is('.dresscode-info')
                && !target.is('.js-popover-button') 
                && !target.is('.js-popover')
                && !target.is('.list-ico')
                && !target.is('.popover-info')
                || target.is('.btn-popover-close')
                ) {
                (
                    ($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false;
            }
        });
    });
    // For popovers on Dining-detail pages
    $('.dresscode-info').click(function () {
        $( this ).next().click();
    });
}

export default jsPopOver;
